export default {
    header: {
        feedback360: '360 Feedback',
        captureInsights: 'Capture insights from all sources',
        forArrowIllustrationAlt: 'Arrow pointing to the right',
        removeReviewee: 'Remove reviewee',
        cannotRemoveReviewee: 'Cannot remove reviewee as the evaluation is already launched',
        cannotRemoveLastReviewee: 'At least one reviewee should be there',
    },
    assignReviewers: {
        title: 'Assign Reviewers',
        description:
            "To make things easier for you, we've already identified potential colleagues who may have worked with <bold>{{firstName}} {{lastName}}</bold>.",
        addReviewer: 'Add Reviewers',
        revieweeBadge: 'Reviewee',
        reviewerAlreadySelected: 'Reviewers already selected',
        noReviewersAssigned: 'No reviewers assigned yet.',
        loadingReviewers: 'Loading reviewers...',
        noReviewersFound: 'No reviewers found',
        searchReviewers: 'Search reviewers',
    },
    selectAttributeModal: {
        title: 'Select a New Attribute',
        add: 'Add',
        attributes: {
            jobTitle: 'Colleagues with the same job title',
            manager: 'Colleagues under the same {{managerLabel}}',
            department: 'Colleagues from the same department',
            supervisor: 'Employees who report to the same supervisor',
            division: 'Employees within the same division',
        },
    },
    validation: {
        title: 'Form incomplete',
        noReviewees: 'Please select at least one reviewee.',
        minReviewers: 'Each reviewee must have at least one reviewer assigned.',
        maxReviewers: 'You can assign a maximum of {{count}} reviewers per reviewee.',
    },
};
